<nav-bar *ngIf="autenticado" titulo="O Melhor Comercial do Brasil" (logoutEvent)="logout($event)"
    [iconeNotificacoes]="false" [botaoPainelAplicacoes]="false" [botaoMenu]="true"></nav-bar>
<router-outlet *ngIf="!autenticado"></router-outlet>
<menu-lateral *ngIf="autenticado" [itensMenu]="menuItens"></menu-lateral>